module.exports = __webpack_public_path__ + "static/media/azure.5e7b90aa.png";